import React from 'react';
import { Layout } from 'react-admin';
import ClubMenu from './ClubMenu';

const ClubLayout = (props) => <Layout
  {...props}
  menu={ClubMenu}
/>;

export default ClubLayout;
